import { Injectable } from "@angular/core";
import { GENERAL_MENU_ELEMENTS } from "../const/menuelements.const";
import { MenuElement } from "../interfaces/interfaces";

@Injectable({
    providedIn: 'root'
})
export class FrameService {
    menuElemments: MenuElement[] = GENERAL_MENU_ELEMENTS;
    logoUrl: string = null;
}